
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDieselEngine as ObiDieselEngineElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diesel-engine.js';
 
 
 

 
 export const ObiDieselEngine = createComponent({
   react: React,
   tagName: 'obi-diesel-engine',
   elementClass: ObiDieselEngineElement,
   events: {
     
   }
  });
 
 